import { SegmentedRatioBar, MatchLabels } from '@/ui/components';

export interface VictoryProbabilityProps {
  /** Home team win probability (0–100). */
  homePercent: number;
  /** Away team win probability (0–100). */
  awayPercent: number;
  /** Home team display name. */
  homeName: string;
  /** Away team display name. */
  awayName: string;
}

export default function VictoryProbability({
  homePercent,
  awayPercent,
  homeName,
  awayName,
}: VictoryProbabilityProps) {
  return (
    <div
      className="flex flex-col w-full pt-[12px] pb-[8px] pl-[8px] pr-[8px]"
      data-testid="victory-probability-content"
    >
      <div className="flex gap-[8px] items-center w-full">
        <div className="flex gap-[2px] items-center leading-[24px] shrink-0 w-[30px] justify-center">
          <span className="font-unibet text-[24px] leading-[24px] text-pmw-label-primary-light dark:text-pmw-label-primary-dark">
            {Math.round(homePercent)}
          </span>
          <span className="font-robotoMedium font-medium text-[16px] leading-[24px] text-pmw-label-tertiary-light dark:text-pmw-label-tertiary-dark">
            %
          </span>
        </div>
        <div className="flex-1 min-w-0">
          <SegmentedRatioBar homePercent={homePercent} awayPercent={awayPercent} />
        </div>
        <div className="flex gap-[2px] items-center leading-[24px] shrink-0 text-center">
          <span className="font-unibet text-[24px] leading-[24px] text-pmw-label-primary-light dark:text-pmw-label-primary-dark">
            {Math.round(awayPercent)}
          </span>
          <span className="font-robotoMedium font-medium text-[16px] leading-[24px] text-pmw-label-tertiary-light dark:text-pmw-label-tertiary-dark">
            %
          </span>
        </div>
      </div>
      <div className="flex gap-[8px] w-full mt-[-4px]">
        <div className="w-[30px] shrink-0" aria-hidden />
        <div className="flex-1 min-w-0 flex flex-col gap-[8px]">
          <MatchLabels homeName={homeName} awayName={awayName} />
        </div>
        <div className="w-[30px] shrink-0" aria-hidden />
      </div>
    </div>
  );
}
